export enum LoginFormKey {
  CAPTCHA = 'captcha',
  EMAIL = 'email',
  PASSWORD = 'password',
}
